import type { FC } from 'react'
import { PatientUser } from '~/shared/types'
import Email from '@mui/icons-material/Email'
import Phone from '@mui/icons-material/Phone'
import Home from '@mui/icons-material/Home'
import { Box, Divider, Fade, Typography } from '@mui/material'
import { format } from 'date-fns'

import PatientDetailPopoverLine from './PatientDetailPopoverLine'
import { formatPhoneNumber } from '~/shared/lib/displayText'
import { usePatientDetail } from './usePatientDetail'

interface PatientContactInfoProps {
  patient: PatientUser
}

export const PatientContactInfo: FC<PatientContactInfoProps> = props => {
  const { onboardingState } = usePatientDetail()

  const address = props.patient.person.insurance_info?.addresses?.[0]
  let formattedAddress: string | null = null
  if (address && address.street_address !== null) {
    formattedAddress = [
      address.street_address,
      address.street_address_2,
      `${address.city}, ${address.state} ${address.zipcode}`,
    ]
      .filter(v => !!v)
      .join('\n')
  }
  return (
    <Box data-testid="patientDetailPopover" sx={{ maxHeight: 800, overflow: 'auto' }}>
      <Box sx={{ py: 2 }}>
        <Box sx={{ mx: 2 }}>
          <Typography>Contact Info</Typography>
        </Box>
        <Box sx={{ mx: 1, mt: 1 }}>
          <PatientDetailPopoverLine value={props.patient.email || ''} icon={Email} />
          <PatientDetailPopoverLine
            value={formatPhoneNumber(props.patient.phone_number ?? '')}
            icon={Phone}
          />
          {formattedAddress && <PatientDetailPopoverLine value={formattedAddress} icon={Home} />}
        </Box>
      </Box>
      <Divider />
      <Box sx={{ p: 2 }}>
        <Fade in={!!onboardingState}>
          <Typography variant="caption">
            <strong>Signed Up: </strong>
            {onboardingState?.signedup_at
              ? format(new Date(onboardingState.signedup_at), 'MMM d, yyyy')
              : '—'}
          </Typography>
        </Fade>
      </Box>
    </Box>
  )
}
